import {
  REMOVE_CATEGORIES,
  ADD_CATEGORY,
  GET_CATEGORIES,
  GET_CATEGORY,
  ADD_PRODUCTS_TO_CATEGORIES,
  REMOVE_PRODUCTS_FROM_CATEGORIES,
  GET_CATEGORIES_FOR_PRODUCT,
  UPDATE_CATEGORY_NAME,
  GET_CATEGORIES_WITH_IDS,
  GET_PRODUCT_GROUPS_FOR_CATEGORY
} from "../constants/action-types";
import { UUID } from "../../helpers/uuid";
import { IncludeType } from "../actions/ProductActions";

// INITIALIZE STATE
const initialState = {
  categories: {},
  category: {},
  categoriesForProduct: {},
  includedInProductGroups: [],
  excludedFromProductGroups: [],
};

// REDUCER
export const CategoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_CATEGORY: {
      const categories = Object.assign({}, state.categories);
      const incomingCategory = action.payload;

      categories[incomingCategory.id] = incomingCategory;

      return {
        ...state,
        categories
      };
    }
    case REMOVE_CATEGORIES: {
      const categories = Object.assign({}, state.categories);
      const outgoingCategories = action.payload;

      outgoingCategories.forEach(categoryId => {
        delete categories[categoryId];
      });

      return {
        ...state,
        categories
      };
    }
    case GET_CATEGORIES: {
      const incomingCategories = action.payload;
      const categories = {};

      incomingCategories.forEach(category => {
        categories[category.id] = category;
      });

      return {
        ...state,
        categories
      };
    }

    case GET_CATEGORIES_WITH_IDS: {
      const incomingCategories = action.payload;
      const categories = Object.assign({}, state.categories);

      incomingCategories.forEach(category => {
        categories[category.id] = category;
      });

      return {
        ...state,
        categories
      };
    }

    case GET_CATEGORY: {
      const categories = Object.assign({}, state.categories);
      const category = action.payload;

      categories[category.id] = category;

      return {
        ...state,
        category: action.payload,
        categories,
      };
    }
    case UPDATE_CATEGORY_NAME: {
      const updatedCategoryId = action.payload.categoryId;
      const newName = action.payload.newName;
      const category = Object.assign({}, state.category);
      const categories = Object.assign({}, state.categories);

      category.Name = newName;
      categories[updatedCategoryId] = category;

      return {
        ...state,
        category,
        categories
      };
    }
    case GET_CATEGORIES_FOR_PRODUCT: {
      const categoriesForProduct = {};
      const categories = action.payload;

      categories.forEach((category) => {
        categoriesForProduct[category.id] = category;
      })

      return {
        ...state,
        categoriesForProduct
      };
    }
    case ADD_PRODUCTS_TO_CATEGORIES: {
      const categoriesForProduct = Object.assign({}, state.categoriesForProduct);
      const categories = Object.assign({}, state.categories);

      const categoryIds = action.payload.categoryIds;
      const productIds = action.payload.productIds;

      let updatedCategory = {};

      categoryIds.forEach(categoryId => {
        let currentCategory = categories[categoryId];

        productIds.forEach(productId => {
          if (!currentCategory.hasOwnProperty("Products") || currentCategory.Products === null) {
            currentCategory.Products = [];
          }

          currentCategory.Products.push(productId);
        });

        if (currentCategory.id === state.category.id) {
          updatedCategory = currentCategory;
        }

        categoriesForProduct[categoryId] = currentCategory;
      });

      return {
        ...state,
        categories,
        category: updatedCategory,
        categoriesForProduct
      };
    }
    case REMOVE_PRODUCTS_FROM_CATEGORIES: {
      const categoriesForProduct = Object.assign({}, state.categoriesForProduct);
      const categories = Object.assign({}, state.categories);

      const productIds = action.payload.productIds;
      const categoryIds = action.payload.categoryIds;

      let updatedCategory = {};

      categoryIds.forEach(categoryId => {
        const currentCategory = categories[categoryId];

        if (currentCategory.hasOwnProperty("Products")) {
          productIds.forEach(productId => {
            const index = currentCategory.Products.findIndex((productKey) => productKey === productId);

            if (index > -1) {
              currentCategory.Products.splice(index, 1);
            }
          });

          if (state.category.id === currentCategory.id) {
            updatedCategory = currentCategory;
          }

          delete categoriesForProduct[categoryId];
        }
      });

      return {
        ...state,
        categories,
        category: updatedCategory,
        categoriesForProduct
      };
    }
    case GET_PRODUCT_GROUPS_FOR_CATEGORY: {
      const productGroupsForCategory = action.payload.data;
      const inclusiveType = action.payload.inclusiveType;

      if (inclusiveType === IncludeType.Include) {
          return {
              ...state,
              includedInProductGroups: productGroupsForCategory,
          }
      } else {
          return {
              ...state,
              excludedFromProductGroups: productGroupsForCategory,
          }
      }
  }
    default:
      return state;
  }
};
